import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const menuButtonDefaultVariants = {}
const menuButtonCompoundVariants = []

const menuButtonSlotNames = [
  [
    "root",
    "menuButton__root"
  ],
  [
    "inner",
    "menuButton__inner"
  ],
  [
    "line",
    "menuButton__line"
  ]
]
const menuButtonSlotFns = /* @__PURE__ */ menuButtonSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, menuButtonDefaultVariants, getSlotCompoundVariant(menuButtonCompoundVariants, slotName))])

const menuButtonFn = memo((props = {}) => {
  return Object.fromEntries(menuButtonSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const menuButtonVariantKeys = [
  "open"
]
const getVariantProps = (variants) => ({ ...menuButtonDefaultVariants, ...compact(variants) })

export const menuButton = /* @__PURE__ */ Object.assign(menuButtonFn, {
  __recipe__: false,
  __name__: 'menuButton',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: menuButtonVariantKeys,
  variantMap: {
  "open": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, menuButtonVariantKeys)
  },
  getVariantProps
})